import React from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getStopsColumns } from './utils/stopsColumns';
import { StopDetailedView } from './types';
import { dataGridSx } from '../common/styled/DataGrid';
import pallet from '../../layouts/pallet';
import CustomDataGridToolbar from '../common/components/CustomDataGridToolbar';

interface StopsTableProps {
  stops: StopDetailedView[];
  onEdit: (stop: StopDetailedView) => void;
  onDelete: (stop: StopDetailedView) => void;
  onAssignStudent: (stop: StopDetailedView) => void;
  loading: boolean;
}

const StopsTable: React.FC<StopsTableProps> = ({
  stops,
  onEdit,
  onDelete,
  onAssignStudent,
  loading
}) => {
  console.log('StopsTable stops:', stops);
  const columns = getStopsColumns(onEdit, onDelete, onAssignStudent);

  return (
    <Box>
      <DataGrid
        rows={stops}
        columns={columns}
        pageSizeOptions={[5, 10, 25, 100]}
        disableRowSelectionOnClick
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          },
          columns: {
            columnVisibilityModel: { id: false }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </Box>
  );
};

export default StopsTable;
